import { h } from "preact";

interface ProductAttributesProps {
  attributes?: Array<{icon: any; name: string}>;
}

/**
 * ProductAttributes - Displays product attributes with SVG icons
 * 
 * **Features:**
 * - Shows multiple attributes with custom SVG icons
 * - Displays attribute names
 * - Handles undefined values gracefully
 * 
 * **Display:**
 * - Only renders if attributes array is provided
 * - Each attribute shows SVG icon and name
 * - Stretches to fill available space
 * 
 * @param attributes - Array of attributes with SVG icon and name
 * @returns JSX element or null
 */
const ProductAttributes = ({ attributes }: ProductAttributesProps) => {
  if (!attributes || attributes.length === 0) return null;

  return (
    <div className="flex flex-col gap-3 flex-1">
      {attributes.map((attribute, index) => (
        <div key={index} className="flex items-start gap-2 md:gap-2.5">
          <div className="w-4 h-4 md:!w-5 md:!h-5 relative flex items-center justify-center">
            {attribute.icon}
          </div>
          <span className="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px]">
            {attribute.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ProductAttributes; 